import React from 'react';
import Button, {ButtonProps} from 'antd/lib/button';
import {SavePersonalApproveParams, UserApi, UserDto} from '../../scaffold';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {useBoolean} from 'react-hanger';
import {message, Modal, Spin} from 'antd';
import PersonalApproveTable from './PersonalApproveTable';
export interface IUserEditBtnProps extends ButtonProps {
  user: UserDto;
  onSuccess?: () => void;
}
export default function UserEditBtn(props: IUserEditBtnProps) {
  const {user, ...rest} = props;
  const findHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userFindGet);
  const isView = useBoolean(false);
  const savePersonalApprove = useOpenApiFpRequest(UserApi, UserApi.prototype.userSavePersonalApprovePost);

  async function onSubmitPersonalApprove(params: SavePersonalApproveParams) {
    try {
      params.userId = props.user.id || 0;
      await savePersonalApprove.request({savePersonalApproveParams: params});
      message.success('已修改');
      findHook.requestSync({id: user.id || 0});
    } catch (e) {
      message.error(e.message);
    }
  }
  return (
    <div>
      <Button
        {...rest}
        onClick={() => {
          findHook.requestSync({id: user.id || 0});
          isView.setTrue();
        }}
      />
      <Modal width={1200} visible={isView.value} onCancel={isView.setFalse} footer={false} title={'会员信息'}>
        <Spin spinning={findHook.loading}>
          {findHook.data && (
            <div className={'p-b-20'}>
              <PersonalApproveTable approve={findHook.data.personalApprove} onSubmit={onSubmitPersonalApprove} loading={savePersonalApprove.loading} />
            </div>
          )}
        </Spin>
      </Modal>
    </div>
  );
}
